import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { navigate } from 'gatsby';

import './BlogPostNavigation.css';
import { BlogPostPropType } from '../../services/proptypes';
import BlogSearch from './components/BlogSearch/BlogSearch';
import BlogPostCard from './components/BlogPostCard';
import BlogPostNavigationHeader from './components/BlogPostNavigationHeader';

export default class BlogPostNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
      searchResults: [],
      searchLoading: false,
    };

    this.onResultSelect = this.onResultSelect.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  onResultSelect(e, { result: { slug } }) {
    navigate(`${slug}/`);
  }

  onSearchChange(e, { value }) {
    this.setState({ searchQuery: value, searchLoading: true }, () => {
      const searchResults = this.getFilteredPosts();
      this.setState({ searchResults, searchLoading: false });
    });
  }

  getFilteredPosts() {
    const { posts } = this.props;
    const { searchQuery } = this.state;

    const re = new RegExp(searchQuery, 'i');
    const isMatch = text => re.test(text);

    return posts.filter(({ title, content, summary }) => {
      return isMatch(title) || isMatch(summary) || isMatch(content);
    });
  }

  render() {
    const { searchQuery, searchLoading, searchResults } = this.state;
    const { posts, title, description, featuredPostId, columns, alwaysShowSearch } = this.props;

    // if nothing is being searched, make sure to always display all posts
    const displayablePosts = searchQuery.length === 0 ? posts : searchResults;

    return (
      <div className="blog-post-navigation">
        <BlogPostNavigationHeader
          posts={posts}
          title={title}
          description={description}
          featuredPostId={featuredPostId}
        />

        {(posts.length > columns - 1 || alwaysShowSearch) && (
          <BlogSearch
            value={searchQuery}
            onResultSelect={this.onResultSelect}
            onSearchChange={this.onSearchChange}
            searchResults={searchResults}
            loading={searchLoading}
          />
        )}

        <Grid stackable columns={columns} className="blog-cards">
          {displayablePosts.map(post => (
            <Grid.Column key={post.title}>
              <BlogPostCard {...post} />
            </Grid.Column>
          ))}
          {displayablePosts.length === 0 && <p> No posts found </p>}
        </Grid>
      </div>
    );
  }
}

BlogPostNavigation.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  featuredPostId: PropTypes.number,
  columns: PropTypes.number,
  alwaysShowSearch: PropTypes.bool,
  posts: PropTypes.arrayOf(BlogPostPropType).isRequired,
};

BlogPostNavigation.defaultProps = {
  title: 'Blog',
  description: '',
  columns: 4,
  alwaysShowSearch: true,
  featuredPostId: null,
};
